// REACT_APP_API_URL is a prefix that ALREADY ends in `/api` (e.g.
// http://47.108.215.19/api). Call sites append the backend sub-path
// WITHOUT an extra `/api` segment (see config/env.js / contentSharing.js).
import { apiFetch } from './apiFetchPolicy';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export async function fetchActivity({ since, sections, limit } = {}) {
  const params = new URLSearchParams();
  if (since) params.set('since', since);
  if (sections) {
    params.set('sections', Array.isArray(sections) ? sections.join(',') : sections);
  }
  if (limit) params.set('limit', String(limit));
  const qs = params.toString();
  return apiFetch(`${API_URL}/activity${qs ? '?' + qs : ''}`);
}

export async function getVapidPublicKey() {
  const data = await apiFetch(`${API_URL}/activity/vapid-public-key`);
  return data && data.publicKey;
}

export async function subscribeWebPush(subscription) {
  return apiFetch(`${API_URL}/activity/push-subscribe`, {
    method: 'POST',
    body: { subscription },
  });
}

export async function subscribeFcm(token) {
  return apiFetch(`${API_URL}/activity/push-subscribe`, {
    method: 'POST',
    body: { provider: 'fcm', token },
  });
}

export default { fetchActivity, getVapidPublicKey, subscribeWebPush, subscribeFcm };
